import { FG_TOKEN_kEY_NAME, REFERRAL_EXPIRED_KEY, REFERRAL_KEY_NAME } from '@lib/constants';
import { BASE_URL } from '@lib/config';
import { getFeatureFlagState } from '@lib/data';

export const getCurrentUrl = () => {
  const url = new URL(BASE_URL ?? 'http://localhost:8000');
  return url.host.replace(/[^\w\s]/gi, '');
};

export const setReferral = async (referrer: string | null | undefined) => {
  if (!referrer) return;

  const currentRef = getReferral(true);
  if (!currentRef || currentRef !== referrer) {
    localStorage.setItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`, referrer);
  }

  // Set the referral expiry time if referrer has value
  await setReferralExpired();
};

export const setReferralExpired = async () => {
  const res = await getFeatureFlagState('affiliate-expiry-minutes', 20000, true);
  const expiryMinutes = res?.value || '60'; // Default to 60 minutes if not set
  const expiryDate = new Date().getTime() + parseInt(expiryMinutes) * 60 * 1000; // Convert hours to milliseconds
  localStorage.setItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`, btoa(expiryDate.toString()));
};

export const checkReferralIsValid = () => {
  const referralExpired = localStorage.getItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`);
  if (!referralExpired || new Date() > new Date(parseInt(atob(referralExpired)))){
    deleteAffiliateData();
    return false;
  }
  return true;
};

export const setFGToken = (token: string | null | undefined) => {
  if (!token) return;
  const currentToken = getFGToken(true);
  if (!currentToken || currentToken !== token) {
    localStorage.setItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`, token);
  }
};

export const getReferral = (isSet: boolean = false) => {
  if(!isSet && !checkReferralIsValid()) return '';
  return (localStorage.getItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`) ?? '').toLowerCase();
};

export const getFGToken = (isSet: boolean = false) => {
  if(!isSet && !checkReferralIsValid()) return '';
  return (localStorage.getItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`) ?? '').toLowerCase();
};

export const deleteAffiliateData = () => {
  localStorage.removeItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`);
  localStorage.removeItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`);
  localStorage.removeItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`);
};
